module.exports = __webpack_public_path__ + "img/aboutUs.a3201bbd.jpg";